/*
创建者 魏强(2018.1.28)
企业品牌 左边广告
*/
<template>
	<div class="module-brand-left">
        <ad-list :data="qyLeftUpAdv.advList" :adDetail="qyLeftUpAdv.adDetails"></ad-list>      
        <ad-list :data="qyLeftDownAdv.advList" :adDetail="qyLeftDownAdv.adDetails"></ad-list>      
    </div>
</template>
<script>
import adList from './ad-list.vue';
export default {
	props:["qyLeftDownAdv","qyLeftUpAdv"],
	components:{
		adList
	},
	data(){
		return {
			
		}
	},
	created(){
	}
}
</script>



// WEBPACK FOOTER //
// index.vue?0352e018